import { IRouteProps } from 'IRoute'

import { List, Show } from '../../pages/Screening'
import permissions from 'commons/constants/permissions'

const path = 'screening'

const route:IRouteProps[] = [
  {
    path: `/${path}`,
    component: List,
    roles: [permissions.SCREENING_ACCESS]
  },
  {
    path: `/${path}/:id`,
    component: Show,
    roles: [permissions.SCREENING_ACCESS]
  }
]

export default route
